import AttachDetails from './AttachDetails';

export default AttachDetails;
